<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MaOrgInspectSelect',
})
</script>
<template>
	<el-tree-select
		v-model="model"
		:data="orgList"
		value-key="id"
		:check-strictly="checkStrictly"
		:render-after-expand="false"
		:props="{ label: 'name', children: 'children' }"
		style="width: 100%"
		:clearable="clearable"
		:filterable="filterable"
		:placeholder="placeholder"
		:disabled="disabled"
		@change="handleChange"
	/>
</template>

<script setup lang="ts" name="MaOrgInspectSelect">
import { ref, computed } from 'vue'
import { apiRequest } from '@/api/common'
const emit = defineEmits(['change'])
defineProps({
	clearable: {
		type: Boolean,
		required: false,
		default: () => true
	},
	filterable: {
		type: Boolean,
		required: false,
		default: () => true
	},
	disabled: {
		type: Boolean,
		required: false,
		default: () => false
	},
	placeholder: {
		type: String,
		required: false,
		default: () => ''
	},
	checkStrictly: {
		type: Boolean,
		default: () => false
	}
})

const model = defineModel<number | string>()
const orgList = ref([])

// 获取机构列表  // 诊断分析
const getOrgList = async () => {
	const res = await apiRequest('get', '/maku/inspect/orgTree')
	orgList.value = res.data
}

const handleChange = (val: any) => {
	emit('change', val)
}

getOrgList()
</script>
